import React from 'react'
import Modal from 'components/modal'
import 'less/edit-survey-id-modal.less'


const I2andQsToolUserModal = props => {
    return (
        <Modal
            title={props.t('i2.qstool.modal.title')}
            isOpen={props.isOpen}
            className="confirmation-modal i2-qsTool-user-modal"
            type="modal"
            autoFocusSubmit={false}
            submitBtnText={props.t('save.and.confirm')}
            onCancel={props.onCancel}
            onSubmit={() => props.onSubmit({ resetPasswordEmail: props.resetPasswordEmail, closeModal: true })}
            isSubmitting={props.isSubmitting}
        >
            <div className="i2-qsTool-user-modal-body">
                <div className="i2-qsTool-user-modal-text">
                    <p> {props.t('i2.qstool.message.1')} </p>
                    <p> {props.t('i2.qstool.message.2')} </p>
                </div>
            </div>
        </Modal>
    )
}

export default I2andQsToolUserModal
